import React from 'react';
import Header from '../components/v3/Header';
import { useStaticQuery, graphql, Link } from 'gatsby';
import BlogPreview from '../components/BlogPreview';
import Footer from '../components/Footer';
import '../components/layout.css';
import '../components/grid.scss';
import './blog.scss';

// Define available blog categories
const CATEGORIES = [
  { name: "All Posts", path: "/blog" },
  { name: "Tutorials", path: "/blog/category/tutorials" },
  { name: "Company", path: "/blog/category/company" },
  { name: "Resources", path: "/blog/category/resources" }
];

const Blog = () => {
  const data = useStaticQuery(graphql`
    {
      allMarkdownRemark(
        filter: {fileAbsolutePath: {regex: "/posts/"}}
        sort: {frontmatter: {date: DESC}}
        limit: 1000
      ) {
        edges {
          node {
            frontmatter {
              path
              title
              date
              description
              keywords
              category
              image {
                childImageSharp {
                  gatsbyImageData(
                    width: 1160
                    formats: [AUTO, WEBP]
                    placeholder: BLURRED
                    quality: 80
                  )
                }
              }
            }
          }
        }
      }
    }
  `);

  const { edges: posts } = data.allMarkdownRemark;

  return (
    <>
    {/* <SEO title="Hyperping Blog" /> */}
    <Header isBlogPage={false} isBlogArticle={true} />
    
    <div className="container">
      <div className="blog-page-header">
        <h1>Blog</h1>
        <p>News, updates and tutorials from the Hyperping team</p>
        
        <div className="blog-categories mt-2em">
          {CATEGORIES.map((cat) => (
            <Link 
              key={cat.path} 
              to={cat.path} 
              className={`blog-category-link ${cat.path === '/blog' ? 'active' : ''}`}
            >
              {cat.name}
            </Link>
          ))}
        </div>
      </div>
      
      <div className="container blog-posts">
        {/* <div className="blog-posts-grid"> */}
          {posts
            .filter(post => post.node.frontmatter.title.length > 0)
            .map(({ node: post }) => <BlogPreview post={post} key={post.frontmatter.path} />)}
        {/* </div> */}
      </div>
    </div>
    
    <Footer />
    </>
  );
};

export default Blog;
